module.exports = ".demo-dialog {\n  color: rebeccapurple; }\n\n.demo-dialog-card {\n  max-width: 350px;\n  margin: 20px 0; }\n"